<script setup>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
</script>

<template>
  <div class="app-root">
    <Header />
    <main class="app-main">
      <router-view />
    </main>
    <Footer />
  </div>
</template>

<style>
html, body, #app, .app-root {
  min-height: 100vh;
  background: #f7faff;
  color: #222;
  font-family: 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
  margin: 0;
  padding: 0;
}
.app-main {
  min-height: calc(100vh - 120px);
  width: 100%;
  margin: 10px auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  padding: 0;
  background: none;
}

/* 白蓝科技风滚动条样式 */
body::-webkit-scrollbar {
  width: 8px;
  background: #eaf3fb;
}
body::-webkit-scrollbar-thumb {
  background: #4ba3fa88;
  border-radius: 8px;
}
</style>
